export default values => {
    const errors = {};
    const requiredFields = ["faq", "homepage", "file"];

    requiredFields.forEach(field => {
        if (
            !values[field] ||
            (values[field].hasOwnProperty("base64") && values[field].base64 === "")
        ) {
            if (field === "file") {
                if (!values["userGuideFileName"]) {
                    errors[field] = "Required";
                }
            } else {
                errors[field] = "Required";
            }
        }
        if (Array.isArray(values[field])) {
            if (values[field].length === 0) {
                errors[field] = "Required";
            }
        }
    });

    return errors;
};
